import { render, staticRenderFns } from "./BankTransferTabModal.vue?vue&type=template&id=66b80ede&scoped=true&"
import script from "./BankTransferTabModal.vue?vue&type=script&lang=js&"
export * from "./BankTransferTabModal.vue?vue&type=script&lang=js&"
import style0 from "./BankTransferTabModal.vue?vue&type=style&index=0&id=66b80ede&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b80ede",
  null
  
)

export default component.exports